/**
 * ユーザーデータテンプレート一覧ページ専用i18n定数
 */

export const USER_DATA_TEMPLATE_LIST_I18N = {
  // ステータス
  status: {
    active: $localize`:@@systemAdmin.userDataTemplateList.status.active:有効`,
    inactive: $localize`:@@systemAdmin.userDataTemplateList.status.inactive:無効`,
  },

  // ダイアログ
  dialog: {
    confirmTitle: $localize`:@@systemAdmin.userDataTemplateList.dialog.confirmTitle:ダイアログ確認`,
    confirmMessage: $localize`:@@systemAdmin.userDataTemplateList.dialog.confirmMessage:ダイアログが表示されます`,
  },

  // メッセージ
  message: {
    updateSuccess: $localize`:@@systemAdmin.userDataTemplateList.message.updateSuccess:パラメータを更新しました。`,
    updateError: $localize`:@@systemAdmin.userDataTemplateList.message.updateError:パラメータの更新に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
  },

  // ボタン
  button: {
    close: $localize`:@@systemAdmin.userDataTemplateList.button.close:閉じる`,
  },
} as const;

export type UserDataTemplateListI18n = typeof USER_DATA_TEMPLATE_LIST_I18N;
